import styled from 'styled-components';

export const SubmittedMessage = styled.p`
  margin-top: 32px;
  text-align: center;
`;
